import { createServerFn } from '@tanstack/react-start';
import { defineQuery } from 'groq';

import type { ComplaintsPolicyQueryResult } from '@/sanity.types';

import { createSanityClient } from './client';
import { legalDocumentProjection } from './legal-document';

export type ComplaintsPolicy = NonNullable<ComplaintsPolicyQueryResult>;

const complaintsPolicyQuery = defineQuery(`*[
  _type == "complaintsPolicy" &&
  _id == "complaintsPolicy"
][0] ${legalDocumentProjection}`);

/** Public server function: it only reads the published complaints policy from Sanity. */
export const getComplaintsPolicy = createServerFn({ method: 'GET' }).handler(
  async (): Promise<ComplaintsPolicy | null> => {
    const client = createSanityClient();

    try {
      return await client.fetch(complaintsPolicyQuery);
    } catch (error) {
      console.error('Failed to load Sanity complaints policy', error);
      return null;
    }
  },
);
